import React from 'react';
import ReactDOM from 'react-dom';
import { MessagePopupContainer, PageOverlay } from './style';
import { ReactComponent as SuccessIcon } from '../../assets/novosicones/SuccessIcon.svg';
import { ReactComponent as ErrorIcon } from '../../assets/novosicones/ErrorIcon.svg';
import CloseButton from '../Reutilizaveis/CloseButton';
import { useContext } from 'react';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

const MessagePopUp = ({
  isError,
  title,
  message,
  children,
  noIcon,
  txtAlign,
  onClose,
  theme,

  containerButtonsDirection,
}) => {
  const { tema } = useContext(ContextoListaApartamentos);
  return ReactDOM.createPortal(
    <PageOverlay>
      <MessagePopupContainer
        txtAlign={txtAlign}
        tema={theme ?? tema}
        containerButtonsDirection={containerButtonsDirection}
        isError={isError}
      >
        {isError && !noIcon && <ErrorIcon />}
        {!isError && !noIcon && <SuccessIcon className='successIcon' />}
        {!onClose && <span className='title'>{title}</span>}

        {onClose && (
          <div className='title-with-close'>
            <span>{title}</span>
            <CloseButton
              onClick={onClose}
              tamanho={32}
              borderColor={'#4d4d4d'}
              color={'#4d4d4d'}
              marginRight={0}
            />
          </div>
        )}
        <p className='message'>{message}</p>
        <div className='container-buttons'>{children}</div>
      </MessagePopupContainer>
    </PageOverlay>,
    document.getElementById('MessagePopup')
  );
};

export default MessagePopUp;
